import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { IntlService } from 'ember-intl';
import type SessionService from 'ember-simple-auth/services/session';
import type LocalizationService from 'volta/services/localization';
import type Transition from "@ember/routing/transition";
import type { Translations } from "ember-intl/-private/utils/translations";

export default class ApplicationRoute extends Route {
  // Services
  // ~~~~~

  @service declare localization: LocalizationService;
  @service declare intl: IntlService;
  @service declare session: SessionService;

  // Lifecycle Hooks
  // ~~~~~


  async beforeModel(_transition: Transition) {
    await this.session.setup();

    if (!this.localization.initialTranslations) {
      const locale = this.localization.defaultLocale;
      const translations = await fetch(`/translations/${locale.value.toLowerCase()}.json`);

      if (translations.ok) {
        const initialTranslations: Translations | undefined = await translations.json();

        if (initialTranslations) {
          this.localization.initialTranslations = initialTranslations;
          this.intl.addTranslations(
            this.localization.defaultLocale.value,
            this.localization.initialTranslations
          );
        }
      }
      this.localization.setLocale(locale.value);
    }
  }
}
